<template>
    <div>
        <pc-alert
            v-model:shown="patternCharactersHelpToggle"
            v-bind:message="patternCharactersHelpText"
            class="mt-2"
            dismissible />
        <pc-table
            key-prop="symbol"
            v-bind:initial-sort="[[2, 'asc']]"
            v-bind:columns="columns"
            v-bind:items="patternMatchItems"
            hide-search
            v-on:help-clicked="onHelpClick">
            <template v-slot:symbol="pmSymbol">
                <div class="text-center">
                    {{ pmSymbol.symbol }}
                </div>
            </template>
        </pc-table>
    </div>
</template>

<script>
    export const PATTERN_MATCH_SYMBOLS = {
        upperA: "A",
        lowerA: "a",
        upperX: "X",
        hash: "#",
        asterisk: "*",
        backslash: "\\"
    };

    import { mapI18n } from "Util/i18n";
    import { NAMESPACE, KEYS } from "./i18n/textValidationRulesTab.i18n";

    export default {
        data() {
            return {
                patternCharactersHelpToggle: false
            };
        },
        computed: {
            columns() {
                return [
                    {
                        header: this.patternCharactersHeader,
                        property: "symbol",
                        searchable: false,
                        orderable: false,
                        visible: true,
                        showHelp: true
                    },
                    {
                        header: this.descriptionHeader,
                        property: "description",
                        searchable: false,
                        orderable: false,
                        visible: true
                    },
                    {
                        header: "Sort Order",
                        property: "tableRow",
                        visible: false
                    }
                ];
            },
            patternMatchItems() {
                return [
                    {
                        symbol: PATTERN_MATCH_SYMBOLS.upperA,
                        description: this.patternCharactersUpper,
                        tableRow: 0
                    },
                    {
                        symbol: PATTERN_MATCH_SYMBOLS.lowerA,
                        description: this.patternCharactersLower,
                        tableRow: 1
                    },
                    {
                        symbol: PATTERN_MATCH_SYMBOLS.upperX,
                        description: this.patternCharactersAnyUpperLower,
                        tableRow: 2
                    },
                    {
                        symbol: PATTERN_MATCH_SYMBOLS.hash,
                        description: this.patternCharactersHash,
                        tableRow: 3
                    },
                    {
                        symbol: PATTERN_MATCH_SYMBOLS.asterisk,
                        description: this.patternCharactersAnyLetterOrNumber,
                        tableRow: 4
                    },
                    {
                        symbol: PATTERN_MATCH_SYMBOLS.backslash,
                        description: this.beginEscapeSequence,
                        tableRow: 5
                    },
                    {
                        symbol: this.anyOtherCharacter,
                        description: this.patternCharactersAnyOther,
                        tableRow: 6
                    }
                ];
            },
            ...mapI18n(KEYS, NAMESPACE)
        },
        methods: {
            onHelpClick() {
                this.patternCharactersHelpToggle = !this.patternCharactersHelpToggle;
            }
        }
    };
</script>
